import { bgStyles } from "../utils/cssStyles";
import { Icon } from "@iconify/react";
import { Box, Container, FormControl, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import React, { useState, useRef, useEffect } from "react";

import Popup from "../components/Popup";
import WithAuth from "../components/WithAuth";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { dashboard } from "../store/dashboardSlice";
import { set } from "date-fns";

import { fetchAccountDetails } from "../store/accountSlice";

function CreateTicket() {
  const [issueType, setIssueType] = useState("");
  const [priority, setPriority] = useState("");
  const [selectProduct, setSelectProduct] = useState("");
  const [summary, setSummary] = useState("");
  const [description, setDescription] = useState("");
  const [bugOptions, setBugOptions] = useState(optionData1);
  const [errorText, setErrorText] = useState("");
  const [allData, setAllData] = useState("");
  const [response, setResponse] = useState("");
  const [flag, setFlag] = useState(false);
  const [loder, setLoder] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const [imageURL, setImageURL] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [errMsg, setErrMsg] = useState("");
  const imageRef = useRef(null);

  const fileInputRef = useRef(null);

  const [email, setEmail] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [sessionResponse, setSessionResponse] = useState("");
  const [sessionFlag, setSessionFlag] = useState(false);

  // const { data } = useSelector((state) => state.dashboard);
  const inputRef = useRef(null);
  
  
  // useEffect(() => {
    //   dispatch(dashboard());
    // }, []);
    
    // const {
      //   customer_name,
      //   products,
      // } = data;
      
  const [accountDetails, setAccountDetails] = useState({
    customer_name: '',
    customer_id: '',
    products: '',
    client_status: '',
    contact_person: '',
    email: '',
    contact_number: ''
  });
      
  const dispatch = useDispatch();
  const {
    data,
    customer_name,
    customer_id,
    products,
    contact_person,
    contact_email,
    contact_number,
    session_response,
    session_flag,
    status,
    error
  } = useSelector((state) => state.account)

  useEffect(() => {
    dispatch(fetchAccountDetails());
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      if (session_flag) {
        setSessionResponse(session_response);
        setSessionFlag(true);
      } else {
        setAccountDetails(data);
        setEmail(contact_email);
        setContactPerson(contact_person);
        setContactNumber(contact_number);
      }
    }
  }, [data]);

  // useEffect(() => {
  //   const fetchAccountDetails = async () => {
  //     try {
  //       const response = await fetch('/meonsupport/account_detail', {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         }
  //       });
  //       const data = await response.json();

  //       if (data.msg === "Logged out") {
  //         setSessionResponse("Session expired. Please login again.");
  //         setSessionFlag(true);
  //       } else {
  //         setAccountDetails(data);
  //         setEmail(data.email);
  //         setContactPerson(data.contact_person);
  //         setContactNumber(data.contact_number);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching account details:", error);
  //     }
  //   };

  //   fetchAccountDetails();
  // }, []);

  const productArray = accountDetails?.products ? accountDetails.products.split(",") : [];

  const handleFileChange = (e) => {
    setImageURL(null);
    if (imageRef.current) {
      imageRef.current.value = null;
    }

    const files = Array.from(e.target.files);
    // const file = e.target.files[0];
    const maxSize = 10 * 1024 * 1024;
    const validFiles = [];

    files.forEach((file) => {
      if (file.size <= maxSize) {
        validFiles.push(file);
      } else {
        setErrMsg("Please select files up to 10MB in size.");
      }
    });

    setUploadFiles(validFiles);
  };

  const handlePaste = (event) => {
    fileInputRef.current.value = null;
    const items = event.clipboardData.items;
    const maxSize = 10 * 1024 * 1024; // 10MB
    const validFiles = [];
    let errorMessage = "";
  
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf("image") === 0) {
        const blob = item.getAsFile();
        if (blob.size <= maxSize) {
          validFiles.push(blob);
          const imageURL = URL.createObjectURL(blob);
          console.log("imageURL", imageURL);
          setImageData(blob);
          setImageURL(imageURL);
        } else {
          errorMessage = "Please select files up to 10MB in size.";
        }
      }
    }
  
    if (errorMessage) {
      setErrMsg(errorMessage);
    } else {
      setUploadFiles(validFiles);
    }
  };

  const handleChangeSummary = (e) => {
    let sum = e.target.value;
    setErrorText("");
    if (sum.length <= 255) {
      setSummary(sum);
    }
  };

  const handleChangeDescription = (e) => {
    let des = e.target.value;
    setErrorText("");
    setDescription(des);
  };

  const handleChangeEmail = (e) => {
    let email = e.target.value;
    setErrorText("");
    setEmail(email);
  };

  const handleChangeContactPerson = (e) => {
    let contactPerson = e.target.value;
    setErrorText("");
    setContactPerson(contactPerson);
  };

  const handleChangeContactNumber = (e) => {
    let contactNumber = e.target.value;
    setErrorText("");
    setContactNumber(contactNumber);
  };

  const handleChangeIssueType = (event) => {
    setIssueType(event.target.value);
    setErrorText("");
    if (event.target.value === "Bug") {
      setBugOptions(optionData1);
      setPriority("Lowest");
    } else {
      setBugOptions(optionData2);
      setPriority("Lowest");
    }
  };

  const handleChangePriority = (event) => {
    setErrorText("");
    setPriority(event.target.value);
  };

  const handleProductChange = (event) => {
    setErrorText("");
    setSelectProduct(event.target.value);
  }

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    uploadFiles.forEach((file) => {
      formData.append("files[]", file); // Use array notation to handle multiple files
    });

    formData.append("summary", summary);
    formData.append("issueType", issueType);
    formData.append("priority", priority);
    formData.append("description", description);
    formData.append("product", selectProduct);
    formData.append("email", email);
    formData.append("contact_person", contactPerson);
    formData.append("contact_number", contactNumber);
    formData.append("customer_name", accountDetails.customer_name);
    formData.append("customer_id", accountDetails.customer_id);
    // formData.append("comments", inputRef.current.value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (summary.length === 0) {
      setErrorText("Summary cannot be blank.");
    } else if (!emailRegex.test(email)) {
      setErrorText("Please enter a valid email address.");
    } else if (!phoneRegex.test(contactNumber)) {
      setErrorText("Please enter a valid phone number.");
    } else if (issueType === "") {
      setErrorText("Please select issue type.");
    } else if (description.length === 0) {
      setErrorText("Description cannot be blank.");
    } else {
      setErrorText("");
      setAllData(formData);
    }
  };

  useEffect(() => { 
    if (allData) {
      setLoder(true);
      // console.log("allData", allData);
      axios.post("/meonsupport/createTicket", allData).then((response) => {
        if (response.data === "Logged out") {
          setLoder(false);
          setSessionResponse("Session expired. Please login again.");
          setSessionFlag(true);
          sessionStorage.removeItem("token");
          // navigate("/login");
        } else {
          setLoder(false);
          setFlag(true);
          setResponse(response.data);
          setIssueType("");
          setPriority("");
          setSummary("");
          setDescription("");
        }
      });
    }
  }, [allData]);
  
  const navigate = useNavigate();
  const handleClose = () => {
    if (response === "Something went wrong") {
      setFlag(false);
    } else {
      navigate("/checkstatus");
    }
  };

  const handleSessionClose = () => {
    setSessionFlag(false);
    navigate("/login");
  }

  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Wrapper>
      <Popup response={response} flag={flag} handleClose={handleClose} />
      <Helmet>
        <title> Create Ticket | Support Tool </title>
      </Helmet>

      {loder ? (
        <div style={bgStyles}></div>
      ) : (
        <Container>
          <Typography variant="h4" sx={{ mb: 5, color: "#103996" }}>
            Create Ticket
          </Typography>
          <form action="" onSubmit={(event) => handleFormSubmit(event)}>
            <Stack
              direction={"column"}
              justifyContent={"center"}
              spacing={3}
              margin={"auto"}
            >
              <TextField
                id="outlined-summary-flexible"
                label="Summary"
                multiline
                maxRows={2}
                className="summaryInput"
                value={summary}
                onChange={handleChangeSummary}
              />
              <p style={{ margin: 0, fontSize: "small" }}>
                {summary.length} / 255
              </p>
              <Box className="selectIssueType">
                <FormControl fullWidth className="issuType">
                  <InputLabel id="demo-simple-select-label">
                    Select Issue Type
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={issueType}
                    label="Select Issue Type"
                    onChange={handleChangeIssueType}
                  >
                    <MenuItem
                      value="Bug"
                      sx={{ fontSize: isBelow768 ? 14 : "" }}
                    >
                      Bug
                    </MenuItem>
                    <MenuItem
                      value="Task"
                      sx={{ fontSize: isBelow768 ? 14 : "" }}
                    >
                      Task / New Requirment (Depends On Approval)
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth className="issuType">
                  <InputLabel id="demo-simple-select-label">
                    Select Priority
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={priority}
                    label="Select Priority"
                    onChange={handleChangePriority}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: 0,
                      },
                      PaperProps: {
                        style: {
                          overflow: "auto",
                        },
                      },
                    }}
                  >
                    {bugOptions.map((option) => (
                      <MenuItem
                        sx={{ fontSize: isBelow768 ? 14 : "" }}
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Product
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectProduct}
                    label="Select Product"
                    onChange={handleProductChange}
                  >
                    {productArray.map((product, index) => (
                      <MenuItem key={index} value={product} sx={{ fontSize: 14 }}>
                        {product}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <FormControl>
                <TextField
                  id="outlined-multiline-static"
                  label="Description"
                  multiline
                  rows={5}
                  value={description}
                  onChange={handleChangeDescription}
                />
              </FormControl>
              <Box className="selectIssueType">
                <FormControl fullWidth className="issuType">
                  <TextField
                    id="outlined-summary-flexible"
                    label="Contact Email"
                    multiline
                    maxRows={2}
                    className="summaryInput"
                    value={email}
                    onChange={handleChangeEmail}
                  />
                </FormControl>

                <FormControl fullWidth className="issuType">
                  <TextField
                    id="outlined-summary-flexible"
                    label="Contact Person"
                    multiline
                    maxRows={2}
                    className="summaryInput"
                    value={contactPerson}
                    onChange={handleChangeContactPerson}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <TextField
                    id="outlined-summary-flexible"
                    label="Contact Number"
                    multiline
                    maxRows={2}
                    className="summaryInput"
                    value={contactNumber}
                    onChange={handleChangeContactNumber}
                  />
                </FormControl>
              </Box>
              <Stack spacing={2}>
                
                  {/* <TextField
                    error={errMsg ? true : false}
                    id="outlined-basic"
                    sx={{ width: "100%", marginTop: "10px" }}
                    label="Comments For Issue !"
                    variant="outlined"
                    inputRef={inputRef}
                    onChange={() => {
                      setErrMsg("");
                    }}
                  /> */}
                  <p
                    style={{
                      color: "red",
                      fontSize: "small",
                      textAlign: "left",
                    }}
                  >
                    {errMsg}
                  </p>
                  <Box style={{ padding: "20px", border: "1px dashed black" }}>
                    <input
                      type="file"
                      name=""
                      sx={{ width: "100%" }}
                      ref={fileInputRef}
                      accept="*/*"
                      id=""
                      onChange={handleFileChange}
                      multiple
                    />
                  </Box>
                </Stack>
                <Box sx={{ color: "#00000087", textAlign: "center" }}>
                  <Typography>Or</Typography>
                </Box>

                <Box
                  onPaste={handlePaste}
                  sx={{
                    minHeight: 100,
                    padding: "15px",
                    border: "1px dashed black",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {imageURL && (
                    <button>
                      <Icon
                        icon={"basil:cross-outline"}
                        width={24}
                        height={24}
                        onClick={() => {
                          setImageURL(null);
                          if (imageRef.current) {
                            imageRef.current.value = null;
                          }
                        }}
                      />
                    </button>
                  )}
                  {!imageURL ? <p>Paste Your Copied Image</p> : ""}
                    <img
                      ref={imageRef}
                      src={imageURL}
                      style={{ maxHeight: 100 }}
                      alt=""
                    />
                  </Box>
              <p style={{ color: "red" }}>{errorText}</p>
              <Button
                type="submit"
                sx={{ padding: "15px" }}
                variant="contained"
              >
                Create Ticket
              </Button>
            </Stack>
          </form>
        </Container>
      )}
      <Popup response={sessionResponse} flag={sessionFlag} handleClose={handleSessionClose} />
    </Wrapper>
  );
}
export default WithAuth(CreateTicket);

const Wrapper = styled.div`
  margin-bottom: 30px;
  .selectoverflow {
    overflow: scroll !important;
  }
  .MuiPopover-paper {
    overflow: auto !important;
  }
  .selectIssueType {
    display: flex;
  }
  .issuType {
    margin-right: 16px;
  }
  @media only screen and (max-width: 768px) {
    .selectIssueType {
      display: flex;
      flex-wrap: wrap;
    }
    .issuType {
      margin-bottom: 24px;
      margin-right: 0px;
    }
  }
`;

const optionData1 = [
  { value: "Lowest", label: "Lowest" },
  { value: "Low", label: "Low " },
  { value: "Medium", label: "Medium " },
  { value: "High", label: "High " },
  { value: "Highest", label: "Highest " },
]

const optionData2 = [
  { value: "Lowest", label: "Lowest - Estimated Resolution Time 5 Weeks" },
  { value: "Low", label: "Low - Estimated Resolution Time 1 Weeks" },
  { value: "Medium", label: "Medium - Estimated Resolution Time 3 Days" },
  { value: "High", label: "High - Estimated Resolution Time 1 Day" },
  { value: "Highest", label: "Highest - Estimated Resolution Time 4 Hours" },
];